// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feedback-popup-container .feedback-input textarea {\n  color: rgba(255,255,255,0.4) !important;\n}\n.feedback-popup-container .feedback-input .van-field__word-limit {\n  position: absolute;\n  bottom: 2px;\n  right: 0px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
